import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {get}from 'lodash';
import classNames from 'classnames';

import Icon from '../Icon';

type NumberInputProps = {
	name: string;
	required?: boolean;
	onFocus?: () => void;
	onBlur?: () => void;
	deletable?: boolean;
	min?: number;
	max?: number;
	steps?: number;
}
export default (props: NumberInputProps) => {
	const {
		name = '',
		required = false,
		onFocus = () => {},
		onBlur = () => {},
		min = 0,
		max = 100,
		steps = 1,
	} = props;

	if (!name) {
		console.warn('Missing prop "name" for NumberInput.');
		return null;
	}

	const {watch, register, errors, setValue, getValues} = useFormContext();
	const isInvalid = Boolean(get(errors, name));
	const value = Number.parseInt(get(getValues({nest: true}), name), 10);
	const hasValue = !Number.isNaN(value);

	const isValidNumber = (value: any) =>
		!Number.isNaN(value)
			&& value >= min
			&& value <= max;

	watch(name);

	return (
		<>
			<input
				className={classNames(
					styles.numberInput,
					isInvalid && styles.isInvalid,
					!isValidNumber(value) && required && styles.isRequired,
				)}
				id={name}
				{...{name, onFocus, onBlur, min, max, steps}}
				ref={register({
					required,
					validate: value => !required || isValidNumber(value)
				})}
				onInput={(e) => {
					const parsedValue = Number.parseInt(e.currentTarget.value, 10);

					setValue(name, isValidNumber(parsedValue) ? parsedValue : '');
					e.preventDefault();
				}}
			/>
			<div className={styles.controls}>
				<Icon
					name="chevron-left"
					onClick={() => setValue(name, hasValue ? Math.max(min, value - steps) : max, true)}
					className={classNames(
						styles.icon,
						(hasValue && value <= min) && styles.disabled
					)}
				/>
				<Icon
					name="chevron-right"
					onClick={() => setValue(name, hasValue ? Math.min(max, value + steps) : min, true)}
					className={classNames(
						styles.icon,
						(hasValue && value >= max) && styles.disabled
					)}
				/>
			</div>
		</>
	);
}
